import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CabService } from 'src/app/_service/cab.service';
import { SharedService } from 'src/app/_service/shared.service';
import { CabDetailsModalComponent } from '../cab-details-modal/cab-details-modal.component';
import {MatDialog} from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-cab-details',
  templateUrl: './cab-details.component.html',
  styleUrls: ['./cab-details.component.css']
})
export class CabDetailsComponent implements OnInit {

  perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;treatment='';pageSizeOptions = [10,25,50,100,200,500];pageIndex:number=0;loaded:boolean=false;
  start_date:string='';end_date:string='';submitted:boolean=false;IpdID:any='';
  cabDetails = [];cab_status:string;search:string;

  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private cabService: CabService, private sharedService: SharedService,private dialog:MatDialog) {}

  ngOnInit(): void {
      this.sharedService.getRole().subscribe((item:string) => {this.myrole=item;});
      this.myrole = localStorage.getItem('role');
  }

  ngAfterViewInit() {
    this.loadCabDetails(0,this.perpage);
  }

  async loadCabDetails(pageIndex:number, perpage:number)
  {
      this.cabDetails = [];
      // this.paginator.pageIndex = pageIndex;
      // this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString = 'search='+this.search+'&cab_status='+this.cab_status+'&date_range='+this.start_date+'-'+this.end_date;
      this.loading = true;this.loaded = false;
      this.cabService.getCabDetails(this.pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = parseInt(data.totaldata);
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
              this.cabDetails = data.data;
          }else{
              this.cabDetails = [];
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedService.checkError(error);
      });
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadCabDetails(event.pageIndex,event.pageSize);
  }

  async markStatus(ipd_id,status)
  {

    const dialogRef = this.dialog.open(CabDetailsModalComponent, {
      width: '60%',height: '70%',
      data:{status,ipd_id}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadCabDetails(0,this.perpage);
    });
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.loadCabDetails(0,this.perpage);
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.loadCabDetails(0,this.perpage);
  }

  exportLeadData()
  {
      if(this.cabDetails.length > 0){
        let data = [];
        let titles = ['Cab Status','Pickup Point','Drop Off Location','Time Of Ride','Price','Contact No','IPD-ID','Requested By','Category','City','Rider Name','Doctor','Created By'];
        data.push(titles);

        this.cabDetails.forEach((cab)=>{
          cab.cabHistories.forEach((cabHistory:any)=>{
              let pickupPoint = cabHistory.pickup_point;
              let dropPoint = cab.hospital_address;
              if(cabHistory.cab_type=='2'){
                pickupPoint = cab.hospital_address;
                dropPoint = cabHistory.pickup_point;
              }
              let pickupTime = formatDate(cabHistory.pickup_datetime*1000, 'dd MMM, yyyy hh:mm aa', 'en-US');
              let exdata = [this.getCabStatus(cabHistory.cab_status), pickupPoint, dropPoint, pickupTime,cabHistory.price, cab.phone, cab.patient_id, cab.bd_name, cab.category_name, cab.circle_name, cab.patient, cab.doctor_name,cabHistory.created_by];
              data.push(exdata);
          });
        });
        let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'cab_history_'+utc+'.xlsx');
      }else{
          this.sharedService.presentToast('Something went wrong, Try Again!');
      }
  }

  getCabStatus(status){
    switch(status){
      case 0:
        return "Pending";
      case 1:
        return "Booked";
      case 2:
        return "Canceled";
      case 3:
        return "Return Booked";
      case 4:
        return "Return Canceled";
      case 5:
        return "Cab Reschedule";
      default:
        return "N/A";
    }
  }

}
